export default __webpack_public_path__ + "img/BFcWMhVB.69a697a4.svg";